'use client';

import { cn } from '@coas/ui/lib';
import Link from 'next/link';
import { usePathname } from 'next/navigation';
import { useMemo } from 'react';
import type { PropsOf } from '~/shared/lib';

type NavLinkProps = Omit<PropsOf<typeof Link>, 'className'> & {
    className?: string;
    activeClassName?: string;
};

export default ({ className, activeClassName, ...props }: NavLinkProps) => {
    const pathname = usePathname();

    const href = useMemo(() => {
        return typeof props.href === 'string' ? props.href : props.href.pathname;
    }, [props.href]);

    return <Link {...props} className={cn(className, pathname === href && activeClassName)} />;
};
